import {
    Box,
    Typography,
    InputAdornment,
    Container,
    Card,
    TextField,
    MenuItem,
    Button,
    Alert,
    CircularProgress,
} from '@mui/material'
import React from 'react'
import axios from 'axios';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import FormProvider from "../../../components/hook-form";
import { format, parse, parseISO, set } from "date-fns";
import { DatePicker } from "@mui/x-date-pickers";
import { dispatch } from 'src/redux/store';
import { getVenue } from 'src/redux/slices/venueSlice';
import { useSnackbar } from 'src/components/snackbar';
import { useNavigate } from "react-router-dom";
import CheckoutReservationPage from "../Checkout/CheckoutReservationPage";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
const getToken = localStorage.getItem("access_token");

export default function SelectReservationTime({
    reservationData,
    setReservationData,
    selectedTableSize,
    selectedDateDft,
    selectedTime,
    detail
}) {

    const venueId = window.location.href.match(/\/venue\/([^\/]+)/)[1];
    const formatTimeFromISO = (isoString) => {
        const date = new Date(isoString);
        let hours = date.getUTCHours();
        let minutes = date.getUTCMinutes();
        const period = hours >= 12 ? 'pm' : 'am';
        let formattedHours = hours % 12;
        formattedHours = formattedHours === 0 ? 12 : formattedHours;
        const paddedHours = formattedHours < 10 ? `0${formattedHours}` : `${formattedHours}`;
        const paddedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;

        return `${paddedHours}:${paddedMinutes} ${period}`;
    };

    const [tableSizes, setTableSizes] = useState(null)
    const [selectedPartySize, setSelectedPartySize] = useState(detail ? detail.partySize : selectedTableSize)
    const [tempTableSize, setTempTableSize] = useState(detail ? detail.partySize : selectedTableSize)
    const [selectedDate, setSelectedDate] = useState(() => {
        let dateString = selectedDateDft || detail?.date;
        return dateString ? new Date(dateString) : new Date();
    });
    const { venue } = useSelector((state) => state.venue);
    const navigate = useNavigate();
    const [selectTime, setSelectTime] = useState(detail ? formatTimeFromISO(detail?.startTime) : selectedTime);
    const [timeSlots, setTimeSlots] = useState([]);
    const [slotsData, setSlotsData] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const [selectAreaFromCards, setSelectAreaFromCards] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [showDetail, setShowDetail] = useState(false)
    const { isLoggedIn } = useSelector((state) => state.login);
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(null)

    useEffect(() => {
        async function fetchData() {
            await dispatch(getVenue(venueId));
        }
        fetchData();
    }, []);

    useEffect(() => {
        if (venue && selectedDate) {
            const rawDate = new Date(selectedDate);
            const formatted = formatDateToYMD(rawDate);
            populateSlotsDropdown(venue, formatted);
        }
    },[]);

    function formatDateToYMD(date) {
        return date.toISOString().split('T')[0];
    }
    const handleInputChange = (value, key) => {
        setSlotsData([]);
        switch (key) {
            case "partySize":
                setSelectedPartySize(value);
                break;
            case "date":
                setSelectedDate(value);
                const changeSlot=true
                const rawDate = new Date(value);
                const formatted = formatDateToYMD(rawDate);
                populateSlotsDropdown(venue, formatted,changeSlot);
                break;
            case "time":
                setSelectTime(value);
                break;
            default:
                break;
        }
        setErrorMessage("Please click on let's go button to see available slots");
    };

    const handleCardSelect = (selectedItem, areaId, tableName, areaName, slotUniqueId, slot) => {
        setSelectAreaFromCards(slotUniqueId);
        setSelectedSlot(slot);

        setReservationData({
            ...reservationData,
            tableId: selectedItem,
            slotUniqueId: slotUniqueId,
            areaId: areaId,
            area: slot.areaId,
            startingTime: slot.startingTime,
            endingTime: slot.endingTime,
        });

        handleNext(slot)
    };

    const tableDataApi = async () => {

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/tables/${venueId}/getSizes`,
                {
                    headers: {
                        Authorization: `Bearer ${getToken}`,
                    },
                }
            );

            setTableSizes(response.data.tableSizes);
        } catch (error) {
            console.log("tablesID error", error.message);
        }
    }

    useEffect(() => {
        tableDataApi();
    }, []);

    const convertDateAndTimeToUtcIsoFormat = (date, time) => {
        const parsedDate = parse(date, 'yyyy-MM-dd', new Date());
        const parsedTime = parse(time, 'hh:mm a', new Date());
        const [hours, minutes] = parsedTime
            .toLocaleTimeString('en-US', { hour12: false })
            .split(':')
            .map(Number);
        const localDateTime = set(parsedDate, { hours, minutes });
        return localDateTime.toISOString();
    };

    useEffect(() => {
        getReservationsTimeSlots()
    }, [])

    const getReservationsTimeSlots = async () => {
        setIsLoading(true);
        setErrorMessage(null);
        setTempTableSize(selectedPartySize)
        let selDate = selectedDate.toISOString().split("T")[0];
        try {
            let payload = {
                date: selDate,
                time: selectTime,
                partySize: selectedPartySize,
                venueId: venue?.id,
                levelId: venue?.levels[0]?.id,
            };

            payload.time = convertDateAndTimeToUtcIsoFormat(payload.date, payload.time);

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/reservation/getReservationTimeSlotsWithParams/b2c`,
                {
                    params: payload,
                }
            );

            setSlotsData(response.data);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    const handleNavigate = () => {
        navigate('/venue')
    }


    const extractTimeFromISOString = (isoString) => {
        const dateObj = new Date(isoString);
        const hour = dateObj.getUTCHours();
        const minute = dateObj.getUTCMinutes();

        return `${(hour % 12 || 12)}:${minute.toString().padStart(2, '0')} ${hour >= 12 ? 'pm' : 'am'}`;
    }
    function populateSlotsDropdown(venueData, selectedDate, changeSlot) {
        setTimeSlots([]);
        let dateObj = new Date(selectedDate);
        let dayOfWeek = dateObj.toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
        let dayTimings = venueData.reservationTimings[dayOfWeek];

        let prevDateObj = new Date(dateObj);
        prevDateObj.setDate(prevDateObj.getDate() - 1);
        let prevDayOfWeek = prevDateObj.toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
        let prevDayTimings = venueData.reservationTimings[prevDayOfWeek];

        if (!dayTimings?.isReservationOn) {
            return;
        }

        let startTime = dayTimings.startTime;
        let endTime = dayTimings.endTime;
        let prevStartTime = prevDayTimings?.startTime;
        let prevEndTime = prevDayTimings?.endTime;

        let start = new Date(`${selectedDate}T${startTime}`);
        let end = new Date(`${selectedDate}T${endTime}`);
        let now = new Date();
        let currentDate = new Date(selectedDate);
        let nextDaySlots = [];

        if (prevEndTime <= prevStartTime && currentDate > now && prevDayTimings?.isReservationOn) {
            nextDaySlots = generateSlots('00:00', prevEndTime, selectedDate, venueData?.reservationSlotTimePeriod);
        }

        if (end <= start) {
            end.setDate(end.getDate() + 1);
        }

        if (now > end) {
            return;
        }

        if (start < now) {
            start = new Date(now);
            start.setSeconds(0, 0);
            let minutes = start.getMinutes();
            let remainder = minutes % 30;
            if (remainder !== 0) {
                start.setMinutes(minutes + (30 - remainder));
            }
            if (start.getMinutes() === 60) {
                start.setMinutes(0);
                start.setHours(start.getHours() + 1);
            }
        }

        let minutes = start.getMinutes();
        if (minutes > 30) {
            start.setMinutes(0);
            start.setHours(start.getHours() + 1);
        } else if (minutes > 0) {
            start.setMinutes(30);
        }

        let midnight = new Date(start);
        midnight.setHours(23, 59, 59, 999);
        if (end > midnight) {
            end = midnight;
        }

        if (start >= end) {
            return;
        }

        let allSlots = [...nextDaySlots];
        let slotDuration = parseInt(venueData?.reservationSlotTimePeriod || 30);
        let currentTime = new Date(start);
        let latestAllowedTime = new Date(end);
        latestAllowedTime.setMinutes(latestAllowedTime.getMinutes() - slotDuration);

        while (currentTime <= latestAllowedTime) {
            let formattedTime = formatTime(currentTime);
            allSlots.push(formattedTime);
            currentTime.setMinutes(currentTime.getMinutes() + 30);
        }

        if (changeSlot === true && allSlots.length > 0) {
            setSelectTime(allSlots[0]);
        }

        if (!allSlots.includes(selectedTime)) {
            setSelectTime(allSlots[0]);
        }
        setTimeSlots(allSlots);
    }
    function generateSlots(startTime, endTime, selectedDate, reservationSlotTimePeriod = 30) {
        let slots = [];
        let currentTime = new Date(`${selectedDate}T${startTime}`);
        let end = new Date(`${selectedDate}T${endTime}`);
        end.setMinutes(end.getMinutes() - parseInt(reservationSlotTimePeriod));
        while (currentTime <= end) {
            slots.push(formatTime(currentTime));
            currentTime.setMinutes(currentTime.getMinutes() + 30);
        }
        return slots;
    }

    function formatTime(date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = hours >= 12 ? 'pm' : 'am';
        let formattedHours = hours % 12 || 12;
        return `${String(formattedHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${ampm}`;
    }

    const handleNext = async (slot) => {
        setError(null)
        localStorage.removeItem("holdStartTime");
        const currentDateTime = dayjs();
        const selectedDay = dayjs(selectedDate);
        const today = dayjs().format('YYYY-MM-DD');
        const selectedDateFormatted = selectedDay.format('YYYY-MM-DD');
        const rawTime = slot?.startingTime.replace('Z', '');
        const slotDateTime = dayjs(rawTime);
        if (selectedDateFormatted === today && currentDateTime.isAfter(slotDateTime)) {
            setError('Slot time has already passed!')
            return;
        }

        const payload = {
            date: selectedDay.format('YYYY-MM-DD'),
            startTime: slot.startingTime,
            endTime: slot.endingTime,
            partySize: tempTableSize.toString(),
            venueId: slot?.venueId,
            levelId: slot?.levelId,
            tableId: slot?.tableId,
            areaId: slot?.areaId?.id,
        };

        try {
            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/reservation/bookSlotTemporary`,
                payload
            );
        }
        catch (error) {
            console.error('API error:', error);
            setError('Something went wrong. Please try again.');
            return;
        }

        if (!isLoggedIn) {
            navigate('/auth/login?type=isReservation', {
                state: {
                    isReservation: {
                        selectedSlot: slot,
                        selectedTableSize: selectedPartySize,
                        detail,
                        confirmationPage: true,
                        logginView: true
                    }
                }
            })
        }
        setShowDetail(true)
    }
    const filteredSlots = Array.isArray(slotsData)
        ? slotsData
            .map((daySlot) => {
                const dateKey = Object.keys(daySlot)[0];
                const values = daySlot[dateKey];
                const fixedSlots = Array(5).fill(null).map((_, i) => values[i] || null);
                const hasAtLeastOneSlot = fixedSlots.some(slot => slot !== null);
                return hasAtLeastOneSlot ? { dateKey, fixedSlots } : null;
            })
            .filter(Boolean)
        : [];

    return (
        <>
            <Box
                sx={{
                    p: {
                        lg: "0px 50px 0px 50px",
                        xl: "0px 50px 0px 50px",
                    }
                }}
            >
                <Container maxWidth="xl" sx={{ marginTop: 2, marginBottom: 2 }}>
                    {!showDetail && <FormProvider>
                        <Card sx={{ width: '100%' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    flexDirection: 'column',
                                    mt: 1,
                                    mb: 1,
                                }}
                            >
                                <Typography
                                    sx={{
                                        font: "Montserrat",
                                        fontWeight: "700",
                                        fontSize: "16px",
                                        marginLeft: '20px',
                                    }}
                                >
                                    Select your slot
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: { md: '1fr 1fr 1fr 100px', xs: '1fr 1fr 1fr ' },
                                    boxSizing: 'border-box',
                                    justifyContent: "center",
                                    gap: "10px",
                                    padding: "0px 16px 16px 16px",
                                    "@media (max-width: 600px)": {
                                        gridTemplateColumns: "1fr",
                                    },
                                }}
                            >
                                <TextField
                                    select
                                    value={selectedPartySize}
                                    onChange={(e) => handleInputChange(e.target.value, "partySize")}
                                    sx={{
                                        width: "100%",
                                        minWidth: "115px",
                                        fontSize: "11px",

                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "12px",
                                            height: 44,
                                        },
                                        "& fieldset": {
                                            borderColor: "#ccc",
                                        },
                                        "& .MuiSelect-select": {
                                            fontSize: {
                                                xs: "11px",
                                                sm: "13px",
                                                md: "14px",
                                            },
                                            paddingTop: "12px",
                                            paddingBottom: "12px"
                                        },
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <img
                                                    src="/assets/icons/reservation/partySize.svg"
                                                    alt="Guests"
                                                    width={18}
                                                    style={{ marginRight: 4 }}
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                >
                                    {!tableSizes?.includes(selectedPartySize) && selectedPartySize && (
                                        <MenuItem key="custom" value={selectedPartySize}>
                                            {selectedPartySize} Guests
                                        </MenuItem>
                                    )}

                                    {tableSizes?.map((number) => (
                                        <MenuItem key={number} value={number}>
                                            {number} Guests
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <DatePicker
                                    value={selectedDate}
                                    onChange={(date) => handleInputChange(date, "date")}
                                    open={open}
                                    onClose={() => setOpen(false)}
                                    onOpen={() => setOpen(true)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            sx={{
                                                width: "100%",
                                                minWidth: "110px",
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: "12px",
                                                    height: 44,
                                                },
                                                "& fieldset": {
                                                    borderColor: "#ccc",
                                                },
                                                "& input": {
                                                    fontSize: {
                                                        xs: "11px",
                                                        sm: "13px",
                                                        md: "14px",
                                                    },
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                },
                                            }}
                                            inputProps={{ ...params.inputProps, readOnly: true }}
                                            InputProps={{
                                                ...params.InputProps,
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <img
                                                            src="/assets/icons/reservation/calendar.svg"
                                                            alt="Calendar"
                                                            width={18}
                                                            style={{ marginRight: 4 }}
                                                        />
                                                    </InputAdornment>
                                                ),
                                                endAdornment: null,
                                            }}
                                            onClick={() => setOpen(true)}
                                        />
                                    )}
                                    minDate={new Date()}
                                />

                                <TextField
                                    select
                                    value={selectTime}
                                    onChange={(e) => handleInputChange(e.target.value, "time")}
                                    sx={{
                                        width: "100%",
                                        minWidth: "110px",
                                        fontSize: "11px",

                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "12px",
                                            height: 44,
                                        },
                                        "& fieldset": {
                                            borderColor: "#ccc",
                                        },
                                        "& .MuiSelect-select": {
                                            fontSize: {
                                                xs: "11px",
                                                sm: "13px",
                                                md: "14px",
                                            },
                                            paddingTop: "12px",
                                            paddingBottom: "12px"
                                        },
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <img
                                                    src="/assets/icons/reservation/clock.svg"
                                                    alt="Time"
                                                    width={18}
                                                    style={{ marginRight: 4 }}
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                >
                                    {timeSlots?.map((time, index) => (
                                        <MenuItem key={index} value={time}>
                                            {time}
                                        </MenuItem>
                                    ))}
                                </TextField>


                                <Box
                                    sx={{
                                        gridColumn: { md: "span 1", xs: "span 3" },
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        sx={{
                                            padding: "10px",
                                            width: "100%",
                                            // color: 'white',
                                            fontSize: '12px',
                                            fontWeight: '700'
                                        }}
                                        onClick={() => getReservationsTimeSlots()}
                                    >
                                        Let's go
                                    </Button>
                                </Box>

                            </Box>
                            {error && (
                                <Box sx={{ p: "15px" }}>
                                    <Alert severity="error">{error}</Alert>
                                </Box>
                            )}
                            {isLoading ? (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginTop: '2rem'
                                }}>
                                    <CircularProgress />
                                </div>
                            ) : (
                                filteredSlots && filteredSlots.length > 0 ? (
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        {filteredSlots.map(({ dateKey, fixedSlots }, idx) => (
                                            <Box key={idx} sx={{ p: "15px" }}>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: "12px" }}>
                                                    {format(parseISO(dateKey), 'EEEE, MMM d, yyyy')}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        display: 'grid',
                                                        gridTemplateColumns: 'repeat(5, 1fr)',
                                                        gap: '10px',
                                                        marginTop: '10px',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    {fixedSlots.map((item, index) => (
                                                        <Box
                                                            key={index}
                                                            sx={{
                                                                backgroundColor: item ? '#F59B34' : '#E0E0E0',
                                                                color: item ? '#fff' : '#888',
                                                                cursor: item ? 'pointer' : 'not-allowed',
                                                                padding: {
                                                                    xs: '8px 20px',
                                                                    sm: '10px 25px',
                                                                    md: '12px 3px',
                                                                    lg: '15px 20px',
                                                                },
                                                                borderRadius: '10px',
                                                                border: item ? '1px solid #F59B34' : '1px solid #ccc',
                                                                textAlign: 'center',
                                                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                                ":hover": item
                                                                    ? {
                                                                        backgroundColor: '#fff',
                                                                        color: '#F59B34',
                                                                    }
                                                                    : {},
                                                            }}
                                                            onClick={() =>
                                                                item &&
                                                                handleCardSelect(
                                                                    item._id,
                                                                    item.areaId.id,
                                                                    item.name,
                                                                    item.areaId.name,
                                                                    item.slotUniqueId,
                                                                    item
                                                                )
                                                            }
                                                        >
                                                            <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                                {item ? extractTimeFromISOString(item.startingTime) : ''}
                                                            </Typography>
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                ) : (
                                    errorMessage ? (
                                        <Box sx={{ textAlign: 'center', width: '100%', margin: '2rem 0rem' }}>
                                            {errorMessage}
                                        </Box>
                                    ) : (
                                        <Box sx={{ textAlign: 'center', width: '100%', margin: '2rem 0rem' }}>
                                            Sorry, no slots are available for this date
                                        </Box>
                                    )
                                )
                            )}
                        </Card>
                    </FormProvider>}
                </Container>
            </Box>
            {showDetail &&
                <CheckoutReservationPage
                    selectedSlot={selectedSlot}
                    selectedTableSize={tempTableSize}
                    detail={detail}
                />
            }
        </>
    );
}
